<template>
  <div class="client opportunity preview">
    <v-tooltip left>
      <v-btn fab dark fixed top right
        slot="activator"
        @click="preview = true"
        :color="themes.client.light.primaryActionButton"
      >
        <v-icon dark>mdi-eye</v-icon>
      </v-btn>
      <span>Preview Opportunity</span>
    </v-tooltip>

    <v-dialog fullscreen scrollable
      :value="preview"
      :overlay="false"
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar card ref="toolbar">
          <v-toolbar-title>Opportunity Preview</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="preview = false" ref="toolbar-close"> <v-icon>mdi-close</v-icon> </v-btn>
        </v-toolbar>
        <v-card-text
          v-if="preview"
          :key="`opportunity-preview-${refreshCount}`"
          class="pa-0"
          style="background-color: rgb(250, 250, 250)"
        >
          <Opportunity />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Opportunity from '@/views/guest/Opportunity'

export default {
  components: {
    Opportunity,
  },
  data() {
    return {
      refreshCount: 1,
      preview: false,
    }
  },
  watch: {
    preview() {
      if (this.preview) this.refresh()
    },
  },
  methods: {
    refresh() {
      this.$store
        .dispatch('opportunities/fetch', this.$route.params.id)
        .then(() => this.refreshCount++)
    },
  },
}
</script>
